<template>
  <div v-if="isPending" :class="$style.loaderContainer">
    <loader />
  </div>

  <article v-else :class="$style.grid">
    <div :class="$style.gridItem">
      <div :class="[$style.header, $style.headerBox]">
        <div :class="$style.header">
          <div>{{ $t('settings.diagnostics.enterSearchText') }}</div>
          <input v-model="searchText" :class="$style.input">
        </div>
        <div :class="$style.header">
          <div>{{ $t('settings.diagnostics.show') }}</div>
          <vue-select
            v-model="selectedOption"
            :class="$style.select"
            :options="options"
            :reduce="(option) => option.id"
            label="name"
            :searchable="false"
            :clearable="false"
          />
        </div>
      </div>
      <div :class="$style.gridItemTableContent">
        <dragTreeTable
          id="diagnosticsDragTable"
          :class="$style.table"
          :data="treeData"
          :label="label"
          :groups="groups"
          table-id="diagnosticsDragTable"
          @redirect="selectRow"
          @action="action"
        />

        <div v-if="!treeData.lists.length" :class="$style.noData">
          {{ $t('table.noData') }}
        </div>
        <div :class="$style.footer">
          <div :class="$style.formInput">
            <div>{{ $t('settings.diagnostics.numberOfDaysAllowed') }}</div>
            <input v-model="numberDays" :class="[$style.input, $style.inputNumber]" type="number" min="0" step="1">
            <button :class="$style.button" @click="update">
              {{ $t('pages.modal.apply') }}
            </button>
          </div>
          <div :class="$style.formInput">
            <div>{{ $t('settings.diagnostics.notifyAboutMissingData') }}</div>
            <input v-model="notifyData" :class="$style.checkbox" type="checkbox">
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedAgent" :class="[$style.gridItem, $style.gridItemRight]">
      <div :class="$style.title">
        Агент
      </div>
      <div :class="$style.form">
        <div>{{ $t('global.user') }}</div>
        <div>{{ selectedAgent.username || noData }}</div>
        <div>{{ $t('settings.diagnostics.columns.placement') }}</div>
        <div>{{ selectedAgent.departName || noData }}</div>
      </div>
      <div :class="$style.form">
        <div :class="$style.titleForm">
          {{ $t('global.computer') }}
        </div>
        <div>{{ $t('global.username') }}:</div>
        <div>{{ selectedAgent.compName || noData }}</div>
        <div>MAC:</div>
        <div>{{ selectedAgent.mac || noData }}</div>
        <div>IP:</div>
        <div>{{ selectedAgent.cip || noData }}</div>
      </div>
      <div :class="$style.form">
        <div :class="$style.titleForm">
          {{ $t('settings.diagnostics.connectingToAnAgent') }}
        </div>
        <div>{{ $t('global.time') }}</div>
        <div>{{ selectedAgent.checktime || noData }}</div>
        <div>{{ $t('global.status') }}</div>
        <div>{{ selectedAgent.status }}</div>
      </div>

      <div :class="$style.form">
        <div :class="$style.titleForm">
          {{ $t('settings.diagnostics.collectingDataFromAnAgent') }}
        </div>
        <div>{{ $t('global.time') }}</div>
        <div>{{ selectedAgent.lastGetLogTime || noData }}</div>
        <div>{{ $t('global.status') }}</div>
        <div>{{ selectedAgent.lastGetLogStatus }}</div>
      </div>

      <div :class="$style.form">
        <div :class="$style.titleForm">
          {{ $t('settings.diagnostics.dataFromAgent') }}
        </div>
        <div>{{ $t('settings.diagnostics.recentLogs') }}:</div>
        <div>{{ selectedAgent.lastLogTime || noData }}</div>
        <div>{{ $t('settings.diagnostics.lastOnOff') }}</div>
        <div>{{ selectedAgent.lastsUp || noData }}</div>
      </div>

      <div :class="[$style.form, $style.formProblem]">
        <div :class="$style.red" />
        <div>{{ $t('settings.diagnostics.missingDataFromAgentForMoreThanSpecifiedPeriod') }}</div>
        <div :class="$style.violet" />
        <div>{{ $t('settings.diagnostics.errorWhenTryingToEstablishAConnectionWithAgent') }}</div>
        <div :class="$style.yellow" />
        <div>{{ $t('settings.diagnostics.errorWhenCollectingLogsFromAgent') }}</div>
      </div>
    </div>
    <modal
      v-if="isViewModal"
      :class="$style.modal"
      :header-text="headerText"
      :button-text="buttonText"
      @close="closeModal"
      @action="updateAgent"
    >
      <template>
        <div v-if="isChange" :class="$style.loaderContainer">
          <loader />
        </div>
        <div v-else :class="$style.modalBody">
          <div v-if="groupId" :class="[$style.modalContainer, { [$style.textContainer]: groupId === 1 }]">
            {{ textConfirmModal }}
          </div>
          <div v-else :class="[$style.formInput, $style.modalContainer]">
            <div :class="$style.label">
              {{ $t('settings.diagnostics.enterNewPassword') }}
            </div>
            <input v-model="password" type="password" :class="$style.input">
          </div>
        </div>
      </template>
    </modal>
  </article>
</template>

<script>
import VueSelect from 'vue-select';
import { getDiagnosticsData, changeAgentPassword, changeUserPassword, changeCompMac } from '@/api/methods/settings';
import Loader from '@/components/common/blocks/loader.vue';
import dayjs from 'dayjs';
import { dateRouter, dateTime } from '@/helpers/filters';
import dragTreeTable from '@/components/pages/agents/drag-tree-table/dragTreeTable.vue';
import { cloneDeep } from 'lodash';
import Modal from '@/components/common/modal/settings-modal.vue';
import { openToast, errorToast, TOAST_TYPE } from '@/utils/open-toast';
import { OPTIONS, TREE_DATA } from './const';

export default {
  components: {
    VueSelect,
    dragTreeTable,
    Loader,
    Modal,
  },
  data() {
    return {
      isChange: false,
      isViewModal: false,
      groupId: null,
      headerText: '',
      buttonText: '',
      password: '',
      selectedItem: null,
      textConfirmModal: '',
      isPending: false,
      searchText: '',
      selectedOption: 1,
      numberDays: +localStorage.getItem('numberDays') || null,
      notifyData: localStorage.getItem('notifyData') === 'true',
      selectedAgent: null,
      options: OPTIONS,
      treeData: TREE_DATA,
      initLists: [],
      noData: this.$t('toast.noData'),
      label: this.$t('settings.diagnostics.action'),
      groups: [
        { id: 0, groupName: this.$t('settings.diagnostics.changeAgentPassword') },
        { id: 1, groupName: this.$t('settings.diagnostics.resetAgentPasswordInDatabase') },
        { id: 2, groupName: this.$t('settings.diagnostics.resetMacAddressInDatabase') },
      ],
    };
  },
  watch: {
    notifyData: {
      handler() {
        localStorage.setItem('notifyData', this.notifyData);
      },
    },
    searchText: {
      handler() {
        this.treeData.lists = this.filteredData();
      },
    },
    selectedOption: {
      handler() {
        this.treeData.lists = this.filteredData();
      },
    },
    initLists: {
      handler() {
        this.treeData.lists = this.filteredData();
      },
    },
  },
  async created() {
    await this.fetch();
    const { packId } = this.$route.query;
    if (packId) this.selectedAgent = this.treeData.lists.find(({ id }) => +packId === id);
  },
  methods: {
    closeModal() {
      this.textConfirmModal = '';
      this.password = '';
      this.isViewModal = false;
    },
    async updateAgent() {
      if (this.isChange) return;
      if (!this.groupId && !this.password.length) {
        openToast(this.$t('settings.diagnostics.enterNewPassword'), TOAST_TYPE.ERROR);
        return;
      }
      try {
        this.isChange = true;
        let message = '';
        const { id, username, compName } = this.selectedItem;

        if (!this.groupId) {
          const { data } = await changeAgentPassword(id, this.password, username, compName);
          if (data.success) message = this.$t('settings.diagnostics.passwordHasBeenSent');
        }
        if (this.groupId === 1) {
          const { data } = await changeUserPassword(id, username, compName);
          if (data.success) message = this.$t('settings.diagnostics.passwordReset');
        }

        if (this.groupId === 2) {
          const { data } = await changeCompMac(id, username, compName);
          if (data.success) message = this.$t('settings.diagnostics.macReset');
        }

        openToast(message, TOAST_TYPE.SUCCSESS);
      } catch (error) {
        errorToast();
      } finally {
        this.isChange = false;
      }
      this.closeModal();
    },
    action(groupId, selectedItem) {
      this.selectedItem = selectedItem;
      this.groupId = groupId;
      if (!groupId) this.buttonText = this.$t('global.change');
      else this.buttonText = this.$t('global.yes');
      if (this.groupId === 1) {
        this.textConfirmModal = this.$t('settings.diagnostics.confirmResetPassword');
      }

      if (this.groupId === 2) {
        this.textConfirmModal = this.$t('settings.diagnostics.confirmResetMac');
      }
      this.headerText = this.groups[groupId].groupName;
      this.isViewModal = true;
    },
    async update() {
      localStorage.setItem('numberDays', this.numberDays);
      await this.fetch();
    },
    async fetch() {
      this.isPending = true;
      const now = dayjs();
      let currentValue = now;
      if (this.numberDays) currentValue = now.subtract(this.numberDays, 'day');

      const dateFrom = dateRouter(currentValue);
      const dateTo = dateRouter(now);
      if (this.$route.query.dateFrom !== dateFrom || this.$route.query.dateTo !== dateTo) {
        this.$router.replace({ query: { ...this.$route.query, dateFrom, dateTo } }).catch(() => {});
      }
      const { data } = await getDiagnosticsData(dateFrom);

      if (data.length) {
        this.treeData.lists = data.map((item) => {
          item.type = 'item';
          item.problem = this.getLogProblem(item);
          item.checktime = item?.checktime ? dateTime(item.checktime) : item.checktime;
          item.lastsUp = item?.lastsUp ? dateTime(item.lastsUp) : item.lastsUp;
          item.error = this.errorField(item);
          item.lastGetLogTime = item?.lastGetLogTime ? dateTime(item.lastGetLogTime) : item.lastGetLogTime;
          item.status = this.$t(`settings.diagnostics.connectionStatus.${item.status}`);
          item.lastGetLogStatus = this.$t(`settings.diagnostics.logStatus.${item.lastGetLogStatus}`);
          return item;
        });
        this.initLists = cloneDeep(this.treeData.lists);
        this.$store.commit('logs/printData/setData', this.treeData.lists);
        this.$store.commit('logs/printData/setColumns', this.treeData.columns);
      }
      this.isPending = false;
    },
    getLogProblem(item) {
      if (!item?.lastLogTime) return 2;
      if (item.status === 0) return 1;
      if (item.lastGetLogStatus === 2) return 0;
      return null;
    },
    errorField(item) {
      const isStatusError = [2, 3, 4].includes(item.status);
      if (isStatusError) return this.$t(`settings.diagnostics.connectionStatus.${item.status}`);
      return item?.lastLogTime ? dateTime(item.lastLogTime) : this.$t('settings.diagnostics.lackOfUpToDateData');
    },
    selectRow(agent) {
      this.$router.replace({ query: { ...this.$route.query, packId: agent.id } });
      this.selectedAgent = agent;
    },
    filteredData() {
      const searchValue = this.searchText.trim().toLocaleLowerCase();
      let lists = cloneDeep(this.initLists);
      if (searchValue) {
        lists = lists
          .filter(({ username }) => username.toLocaleLowerCase().includes(searchValue))
          .filter(({ compName }) => compName.toLocaleLowerCase().includes(searchValue));
      }
      if (this.selectedOption) {
        lists = lists.filter(({ lastLogTime }) => !lastLogTime);
      }
      return lists;
    },
  },
};
</script>

<style lang="scss" module>
  .loaderContainer {
    height: 100%;
    width: 100%;
  }
  .grid {
    display: flex;
    gap: 10px;
    background: white;
    height: 100%;
    border-left: 1px solid $borderColor;
    border-bottom: 1px solid $borderColor;
    overflow: auto;
  }

  .gridItem {
    flex: 0 0 60%;
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  .gridItemRight {
    flex: 0 0 39%;
    padding: 0 10px;
    gap: 10px;
  }

  .gridItemTableContent {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-right: 1px solid $borderColor;
    margin-top: 10px;
  }

  .header {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
  }

  .headerBox {
    padding-left: 12px;
  }

  .input {
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    color: #333;
    line-height: 1.4;
    padding: 5px;
  }

  .inputNumber {
    width: 70px;
  }

  .select {
    min-width: 220px;
  }

  .footer {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
  }

  .formInput {
    display: flex;
    gap: 10px;
    align-items: center;
    height: 30px;
  }
  .checkbox {
    height: 20px;
    margin: auto 0 3px 0;
    cursor: pointer;
    accent-color: #2985bf;
  }

  .form {
    display: grid;
    grid-template-columns: 150px auto;
    gap: 10px;
    font-style: normal;
    font-size: 14px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    padding: 10px;
  }
  .formProblem {
    grid-template-columns: auto auto;
  }

  .title {
    font-size: 16px;
    margin-bottom: 5px;
    font-weight: 500;
    padding-left: 10px;
    line-height: 30px;
  }

  .titleForm {
    grid-column: 1 / -1;
    font-weight: 500;
  }

  .noData {
    padding: 10px;
    font-size: 12px;
    background-color: #f5f5f5;
  }

  .violet {
    background: $violet;
  }

  .yellow {
    background: $yellow;
  }

  .red {
    background: $red;
  }

  .button {
    border: none;
    background: #2985bf;
    cursor: pointer;
    height: 30px;
    color: white;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    &:disabled {
      background: $branchColor;
      border: $branchColor;
    }
  }

  .modalContainer {
    padding: 0 20px;
    text-align: center;
  }
  .textContainer {
    padding: 0 50px;
    text-align: justify;
  }
</style>

<style>
  .settings-modal_modal_3LaCC {
    width: 25%;
  }
  .drag-tree-table {
    margin: 0;
    color: black;
  }

  .drag-tree-table-header {
    background: #f5f5f5;
    line-height: 20px;
  }
</style>
